import * as React from 'react';
import wrapStore from '@src/utils/wrap-store';

import NaviBarStore from '@src/business-components/navibar/store';
import sliceArr from '@src/utils/slice-arr';
import Link from '@src/components/link';
import { isArray } from '@src/utils/type-utils';
import CultureSwiper from '@src/business-components/navibar/components/culture-swiper';
import cx from 'classnames';
import LanguageSelect from '../language-select';
import aos from '../../utils/aos';
import { convertNavObjToArr, isSameWebsite } from './helper';

const styles = require('./index.less');

/**
 *
 * @param {{ store: NaviBarStore }} props
 * @returns
 */
const NaviBar = ({ store }) => {
  store.use();
  const renderNestedList = list => {
    const renderListItem = items => {
      return items.map((item, key) => {
        return (
          <Link key={key} className={styles.gameItem} href={item.link} target={'_blank'}>
            <div className={styles.gameIcon}>
              <img src={item.icon} alt="" />
            </div>
            <div className={styles.gameInfo}>
              <div className={styles.gameName}>{item.title}</div>
              <div className={styles.gameDesc}>{item.desc}</div>
            </div>
          </Link>
        );
      });
    };
    const renderListCol = (games, allGame) => {
      const _arr = sliceArr(games, 5);

      return _arr.map((item, key) => {
        return (
          <div className={styles.gameListCol} key={key}>
            {renderListItem(item)}
            {allGame && (
              <Link className={styles.moreGamesBtn} href={allGame.link} target="_blank">
                <span className={styles.moreGamesBtnContent}>{allGame.title}</span>
              </Link>
            )}
          </div>
        );
      });
    };

    return list.map((item, key) => {
      const title = item.nav_title;
      const navLink = item.nav_url;

      if (navLink) {
        const active = isSameWebsite(navLink);
        const linkProps = active ? {} : { href: navLink, target: '_blank' };
        // const linkUrl = active ? '' : navLink;
        return (
          <Link
            key={title}
            className={cx(styles.gameMenuItem, active && [styles.active, styles.disabled])}
            {...linkProps}
          // onClick={() => store.toLink(title, linkUrl)}
          >
            <span className={styles.gameType}>{title}</span>
          </Link>
        );
      }

      const games = convertNavObjToArr(item);
      const allGame = item.all_game_text ? { title: item.all_game_text, link: item.all_game_url } : undefined;
      return (
        <div className={styles.gameMenuItem} key={key}>
          <span className={styles.gameType}>{title}</span>
          <div className={styles.gameList}>
            <div className={styles.listContainer}>{renderListCol(games, allGame)}</div>
          </div>
        </div>
      );
    });
  };

  /**
   * 渲染精品游戏
   * @returns {unknown[]|null}
   */
  const renderRecommendGameList = () => {
    const recommendGameList = convertNavObjToArr(store.expandedNavList[0]);

    return recommendGameList.map((item, key) => {
      return (
        <Link className={styles.recommendGameItem} key={key} href={item.link} target={'_blank'}>
          <div
            className={styles.recommendGameIcon}
            style={{
              backgroundImage: `url(${item.icon})`
            }}
          />
          <div className={styles.recommendGameName}>{item.title}</div>
        </Link>
      );
    });
  };
  /**
   * 渲染链接部分
   * @param linkArr
   * @returns {*|null}
   */
  const renderLink = linkArr => {
    if (!isArray(linkArr)) {
      return null;
    }
    return linkArr.map((item, key) => {
      return (
        <div className={styles.linkItem} key={key}>
          <Link className={styles.linkItemContent} href={item.link} target={'_blank'}>
            {item.title}
          </Link>
        </div>
      );
    });
  };

  const renderLoginContent = () => {
    if (store.account) {
      return (
        <div className={styles.loggedInContent}>
          <div className={styles.userName}>
            {store.account}
            <div className={styles.iconArrow} />

            <div className={styles.userWarp}>
              <Link className={styles.item} onClick={() => store.clickJobRecord()}>
                投递记录
              </Link>
              <div className={styles.line} />
              <Link className={styles.item} onClick={() => store.logout()}>
                退出登录
              </Link>
            </div>
          </div>
        </div>
      );
    } else
      return (
        <Link className={styles.loginBtn} onClick={() => store.clickLogin()}>
          登录
        </Link>
      );
  };

  return (
    <div className={cx(styles.root, store.isActive && styles.rootAct, 'aos-animate')} {...aos.FADE_IN()} data-aos-once="true" data-flm-layer-name="header">
      {/*<div className={cx(styles.expandNaviBar, store.isExpand && styles.expandNav)} onMouseLeave={store.closeExpandMenu}>*/}
      <div className={cx(styles.expandNaviBar, store.isExpand && styles.expandNav)} onMouseLeave={store.closeExpandMenu}>
        <div className={styles.whiteNaviBarContainer}>
          <div className={styles.whiteNaviBarTop}>
            <Link className={styles.blackLogo} href={store.layerData.seasun_logo_link} target="_blank">
              <img src={store.layerData.seasun_logo_active} alt="logo" />
            </Link>
            {/*<Link className={styles.closeBtn} onClick={store.closeExpandMenu} />*/}
          </div>
          <div className={styles.whiteNaviBarBottom}>
            <div className={styles.whiteNaviBarBottomLeft}>
              <div className={styles.boutiqueGamesList}>
                <div className={styles.expandNavBarTitle}>{store.expandedNavList[0]?.nav_title}</div>
                <div className={styles.expandRecommendGameList}>{renderRecommendGameList()}</div>
                <div className={styles.expandRecommendGameMoreBtn}>
                  <Link className={styles.expandRecommendGameMoreBtnContent} href={store.expandedNavList[0]?.more_game_url} target={'_blank'}>
                    {store.expandedNavList[0]?.more_game_text}
                  </Link>
                  <div className={styles.arrowIcon_dark} />
                </div>
              </div>
              <div className={styles.dividerLine} />
              <div className={styles.linkContainer}>
                {store.expandedNavList.slice(1).map(nav => (
                  <div key={nav.nav_title} className={styles.linkCol}>
                    <div className={styles.expandNavBarTitle}>{nav.nav_title}</div>
                    <div className={styles.linkList}>{renderLink(convertNavObjToArr(nav))}</div>
                  </div>
                ))}
              </div>
            </div>
            <div className={cx(styles.whiteNaviBarBottomRight, store.isExpand && styles.show)}>
              <CultureSwiper store={store.cultureSwiperStore} list={store.cultureSwiperList} />
            </div>
          </div>
        </div>
      </div>
      <div className={cx(styles.expandNavCover, store.isExpand && styles.showNavCover)} />
      <div className={styles.mainNaviBar}>
        {store.isLoading && (
          <div className={styles.loadingBox}>
            <div className={styles.loadingContent} />
          </div>
        )}
        <div className={styles.mainNavBarContainer}>
          <div className={styles.leftBox}>
            <div className={styles.logoMenu} onMouseOver={store.onLogoMenuHover}>
              <img className={styles.logoIcon} src={store.layerData.seasun_logo} alt="logo" />
              <div className={styles.arrowIcon} />
            </div>
            {renderNestedList(store.navList)}
          </div>
          <div className={styles.rightBox}>
            {renderNestedList(store.rightNavList)}

            <div className={styles.loginContent}>{renderLoginContent()}</div>

            <div className={styles.changeLanguageBtn}>
              <LanguageSelect buttonDisplay={'nav'} />
            </div>
          </div>
        </div>
        <div className={styles.bg} />
      </div>
    </div>
  );
};

export default wrapStore(NaviBar, NaviBarStore);
